//@flow

import React from 'react';

import type { Crust } from './domain/pizza';
import { impossible } from './domain/utils';
import Normal from '../../../../assets/images/pages/pizza/fields/pizza_kiji_futsu@3x.png';
import Thick from '../../../../assets/images/pages/pizza/fields/pizza_kiji_fukkura@3x.png';
import Thin from '../../../../assets/images/pages/pizza/fields/pizza_kiji_usui@3x.png';

type Props = {
  crust: Crust,
};

export default class PizzaCrust extends React.PureComponent<Props> {
  get imgSrc(): string {
    switch (this.props.crust) {
      case 'thin_crust':
        return Thin;
      case 'normal_crust':
        return Normal;
      case 'thick_crust':
        return Thick;
      default:
        return impossible(this.props.crust);
    }
  }

  render() {
    return <img src={this.imgSrc} className="pizza-image pizza-crust" />;
  }
}
